import React from "react";
import DetailCar from "./DetailCar";

const CarTop = () => {
    return <DetailCar />;
};

export default CarTop;
